import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';
import type {
  CronofyDataCenter,
  CronofyElementType,
} from '@efdigital/ll-cdk-coaching-cronofy-api-types';

import { parseAdminSessionsErrorResponse } from './admin-sessions.ts';

const CRONOFY_API_PREFIX = '/ll-coaching-cronofy/admin';

/**
 * `@efdigital/ll-cdk-coaching-cronofy-api-types` doesn't publish these yet —
 * the admin element-token endpoint hasn't merged/released on the CDK side.
 * Typed locally to match its documented contract; swap for the real import
 * once a release picks it up.
 */
export interface AdminPostElementTokenResponseBody {
  elementToken: string;
  accountSub: string;
  dataCenter: CronofyDataCenter;
}

export async function buildAdminElementTokenRequest(
  session: SessionService,
  coachId: string,
  elementType: CronofyElementType,
  origin: string
): Promise<Request> {
  const init = await addCurrentAuthHeader(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ origin }),
    },
    { session }
  );

  return new Request(
    `${session.apis.systemsApi.host}${CRONOFY_API_PREFIX}/coaches/${encodeURIComponent(coachId)}/element-token/${encodeURIComponent(elementType)}`,
    init
  );
}

export async function parseAdminElementTokenResponse(
  response: Response
): Promise<AdminPostElementTokenResponseBody> {
  if (!response.ok) {
    return parseAdminSessionsErrorResponse(response);
  }

  return (await response.json()) as AdminPostElementTokenResponseBody;
}
